export default __webpack_public_path__ + "static/media/waterfloor.d858b265.png";